import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'

const container = document.getElementById('root')
if (container === null) throw new Error('ไม่พบ #root ใน index.html')

const root = createRoot(container)

/**
 * /__preview เป็นหน้าดูตัวอย่าง Gantt/ปฏิทินด้วยข้อมูลจำลอง
 *
 * ต้องแยกสาขาตั้งแต่ตรงนี้ด้วย dynamic import ไม่ใช่ทำเป็น route ใน App
 * เพราะ App → auth → firebase.ts จะโยน error ทันทีที่โหลด ถ้ายังไม่ได้ตั้ง .env
 * หน้า preview จึงต้องไม่แตะ module สายนั้นเลย ถึงจะเปิดดูได้ก่อนตั้งค่า Firebase
 */
if (import.meta.env.DEV && window.location.pathname === '/__preview') {
  const { PreviewPage } = await import('./features/devtools/PreviewPage')
  root.render(
    <StrictMode>
      <PreviewPage />
    </StrictMode>,
  )
} else {
  const { App } = await import('./App')
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  )
}
